import { MEASURE, MeasureApplicableContext } from '@adtrackify/at-tracking-event-types';

import { createTableColumnsStore } from './create-table-columns-store';
import type { TableColumn } from './types/table-columns-types';
import { getMeasureCategory } from '@/lib/helpers/measures/measure-definitions';

export const DEFAULT_ECOMMERCE_COLUMNS: TableColumn[] = [
  {
    id: 'orders',
    label: 'Orders',
    measure: MEASURE.ORDERS_COUNT,
    category: getMeasureCategory(MEASURE.ORDERS_COUNT) || 'Unknown',
    visible: true,
  },
  {
    id: 'gross-sales',
    label: 'Gross Sales',
    measure: MEASURE.ORDERS_GROSS_REVENUE,
    category: getMeasureCategory(MEASURE.ORDERS_GROSS_REVENUE) || 'Unknown',
    visible: true,
  },
  {
    id: 'net-sales',
    label: 'Net Sales',
    measure: MEASURE.ORDERS_NET_REVENUE,
    category: getMeasureCategory(MEASURE.ORDERS_NET_REVENUE) || 'Unknown',
    visible: true,
  },
  {
    id: 'total-revenue',
    label: 'Total Revenue',
    measure: MEASURE.ORDERS_TOTAL_REVENUE,
    category: getMeasureCategory(MEASURE.ORDERS_TOTAL_REVENUE) || 'Unknown',
    visible: true,
  },
  {
    id: 'gaov',
    label: 'Gross AOV',
    measure: MEASURE.ORDERS_GROSS_AOV,
    category: getMeasureCategory(MEASURE.ORDERS_GROSS_AOV) || 'Unknown',
    visible: true,
  },
  {
    id: 'customers',
    label: 'Customers',
    measure: MEASURE.ORDERS_UNIQUE_CUSTOMERS,
    category: getMeasureCategory(MEASURE.ORDERS_UNIQUE_CUSTOMERS) || 'Unknown',
    visible: true,
  },
  {
    id: 'new-customers',
    label: 'New Customers',
    measure: MEASURE.ORDERS_NEW_CUSTOMERS,
    category: getMeasureCategory(MEASURE.ORDERS_NEW_CUSTOMERS) || 'Unknown',
    visible: true,
  },
  {
    id: 'new-customer-gross-sales',
    label: 'New Customer Gross Sales',
    measure: MEASURE.ORDERS_NEW_CUSTOMER_GROSS_REVENUE,
    category: getMeasureCategory(MEASURE.ORDERS_NEW_CUSTOMER_GROSS_REVENUE) || 'Unknown',
    visible: true,
  },
  {
    id: 'new-customer-net-sales',
    label: 'New Customer Net Sales',
    measure: MEASURE.ORDERS_NEW_CUSTOMER_NET_REVENUE,
    category: getMeasureCategory(MEASURE.ORDERS_NEW_CUSTOMER_NET_REVENUE) || 'Unknown',
    visible: true,
  },
];

export const useEcommerceTableColumnsStore = createTableColumnsStore(
  'ecommerce-table',
  DEFAULT_ECOMMERCE_COLUMNS,
  {
    version: 1,
    context: MeasureApplicableContext.CUSTOM_DASHBOARD,
  }
);

